<!-- =========================================================
     CIRCLEDPLUS LOGIN PAGE
========================================================= -->

<div
  class="login-layout w-full min-h-screen grid grid-cols-1 lg:grid-cols-2 bg-[#fffcf9] overflow-x-hidden">

  <!-- =======================================================
       DESKTOP IMAGE PANEL
  ======================================================== -->
  <section class="auth-hero hidden lg:block" aria-label="CircledPlus private marketplace">
    <img class="auth-hero-image" src="assets/img/Circled_Plus_Login.webp"
         alt="Luxury apartment in Bengaluru" width="720" height="1080" />
    <div class="auth-hero-shade" aria-hidden="true"></div>
    <div class="auth-hero-copy">
      <span class="auth-hero-label">Circled+ Private Marketplace</span>
      <p class="auth-hero-kicker">Private Member Access</p>
      <h1>Discover Bengaluru’s<br>finest homes.</h1>
      <p>Curated properties, private access and smarter decisions for discerning home buyers.</p>
    </div>
  </section>



  <!-- =======================================================
       LOGIN PANEL
  ======================================================== -->
  <main
    class="w-full min-h-screen
           bg-[#fffcf9]"
  >

    <!-- Natural document flow on mobile.
         Desktop gets vertical centering. -->
    <div
      class="login-panel w-full min-h-screen flex flex-col items-center
             px-5 py-7
             sm:px-8 sm:py-10
             lg:px-12 xl:px-16
             lg:justify-center"
    >

      <!-- Content width -->
      <div class="login-content w-full max-w-[500px]">


        <!-- =================================================
             LOGO
        ================================================== -->
        <div class="flex justify-center mb-7">

          <a routerLink="/" class="auth-logo-link" aria-label="CircledPlus home">
            <img
              src="/cir-home/images/circledplus-logo.svg"
              alt="CircledPlus"
              class="auth-logo"
            width="156" height="40" />
          </a>

        </div>


        <!-- =================================================
             HEADER
        ================================================== -->
        <div class="text-center mb-7">

          <div
            class="inline-flex items-center gap-2 mb-4"
          >
            <span
              class="w-1.5 h-1.5 rounded-full"
              style="background:#8c52ff;"
            ></span>

            <span
              class="text-[11px] font-bold uppercase tracking-[0.2em]"
              style="color:#7641cf;"
            >
              Private Member Access
            </span>

            <span
              class="w-1.5 h-1.5 rounded-full"
              style="background:#8c52ff;"
            ></span>
          </div>


          <h2
            class="font-bold leading-tight"
            style="
              font-family:'Georgia','Times New Roman',serif;
              font-size:clamp(2rem,5vw,2.7rem);
              color:#242126;
              letter-spacing:-1px;
            "
          >
            Welcome back
          </h2>


          <p
            class="mt-3 text-[15px] leading-relaxed"
            style="color:#706971;"
          >
            Sign in to access your curated collection
            of luxury homes across Bengaluru.
          </p>

        </div>


        <!-- =================================================
             COMPLIMENTARY ACCESS BANNER
        ================================================== -->
        <div class="mb-7">

          <div
            class="flex items-center gap-3 rounded-2xl px-4 py-4"
            style="
              background:#f7f3fc;
              border:1px solid #e5d9f5;
            "
          >

            <!-- Diamond icon -->
            <div
              class="w-10 h-10 shrink-0 rounded-full flex items-center justify-center"
              style="background:#f0e8fc;"
            >
              <svg
                width="19"
                height="19"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M12 2L2 9l10 13L22 9 12 2z"
                  stroke="#8c52ff"
                  stroke-width="1.7"
                  stroke-linejoin="round"
                />
                <path
                  d="M2 9h20M12 2l-5 7M12 2l5 7"
                  stroke="#8c52ff"
                  stroke-width="1.7"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>

            <div class="min-w-0">

              <p
                class="text-sm font-bold"
                style="color:#7641cf;"
              >
                Complimentary access
              </p>

              <p
                class="text-xs mt-0.5"
                style="color:#706971;"
              >
                Explore 3 curated luxury homes at no cost
              </p>

            </div>

          </div>

        </div>


        <!-- =================================================
             LOGIN FORM
        ================================================== -->
        <form
          [formGroup]="loginForm"
          (ngSubmit)="loginForm.valid && loginUser()"
          class="space-y-5"
          novalidate
        >

          <!-- ===============================================
               PHONE / EMAIL
          ================================================ -->
          <div>

            <label
              for="auth"
              class="block text-sm font-semibold mb-2"
              style="color:#242126;"
            >
              Phone / Email address
            </label>


            <!-- Input wrapper -->
            <div class="relative">

              <!-- Input -->
              <input
                id="auth"
                type="text"
                formControlName="phone"
                required
                autocomplete="email"
                (input)="onAuthInput($event)"
                (focus)="phoneFocused = true"
                (blur)="phoneFocused = false"
                [class.pl-28]="isPhoneInput()"
                [class.pl-12]="!isPhoneInput()"
                class="block w-full h-14 pr-4 rounded-2xl text-[16px]"
                placeholder="Enter your phone or email"
                style="
                  background:#ffffff;
                  border:1.5px solid #e7e1dc;
                  color:#242126;
                  outline:none;
                  box-sizing:border-box;
                  -webkit-appearance:none;
                  appearance:none;
                "
                [style.border-color]="
                  phoneFocused
                    ? '#8c52ff'
                    : (loginForm.get('phone')?.invalid && loginForm.get('phone')?.touched)
                      ? '#e87070'
                      : '#e7e1dc'
                "
              />


              <!-- =========================================
                   PHONE COUNTRY SELECTOR
              ========================================== -->
              <div
                class="absolute inset-y-0 left-0 flex items-center pl-2"
                *ngIf="isPhoneInput()"
              >

                <button
                  type="button"
                  (click)="toggleDropdown()"
                  class="h-10 flex items-center gap-1.5 px-2.5 rounded-xl"
                  style="
                    background:#f7f3fc;
                    color:#706971;
                    border:1px solid #e5d9f5;
                  "
                >

                  <span class="text-lg leading-none">
                    {{ selectedCountry.flag }}
                  </span>

                  <span
                    class="text-xs font-semibold"
                    style="color:#706971;"
                  >
                    {{ selectedCountry.dial }}
                  </span>

                  <span
                    class="text-[9px] ml-0.5"
                    style="color:#827a83;"
                  >
                    {{ dropdownOpen ? '▲' : '▼' }}
                  </span>

                </button>


                <!-- =========================================
                     COUNTRY DROPDOWN
                ========================================== -->
                <div
                  *ngIf="dropdownOpen"
                  class="absolute left-0 top-[calc(100%+8px)] z-[100] w-[min(320px,calc(100vw-40px))] rounded-2xl overflow-hidden"
                  style="
                    background:#ffffff;
                    border:1px solid #e7e1dc;
                    box-shadow:0 18px 45px rgba(0,0,0,0.14);
                  "
                >

                  <!-- Search -->
                  <div
                    class="p-3"
                    style="border-bottom:1px solid #e7e1dc;"
                  >

                    <input
                      type="text"
                      [value]="searchQuery"
                      (input)="searchQuery = $any($event.target).value"
                      placeholder="Search country..."
                      class="w-full h-11 rounded-xl px-3 text-[16px] outline-none"
                      style="
                        border:1px solid #e7e1dc;
                        background:#fffcf9;
                        color:#242126;
                        box-sizing:border-box;
                      "
                    />

                  </div>


                  <!-- Countries -->
                  <ul
                    class="max-h-60 overflow-y-auto overscroll-contain"
                  >

                    <li
                      *ngFor="let country of filteredCountries"
                      (click)="selectCountry(country)"
                      class="flex items-center gap-3 px-4 py-3 cursor-pointer text-sm transition-colors"
                      [style.background]="
                        country.code === selectedCountry.code
                          ? '#f7f3fc'
                          : '#ffffff'
                      "
                    >

                      <span
                        class="text-lg w-7 text-center shrink-0"
                      >
                        {{ country.flag }}
                      </span>

                      <span
                        class="flex-1 min-w-0"
                        style="color:#242126;"
                      >
                        {{ country.name }}
                      </span>

                      <span
                        class="font-medium text-xs"
                        style="color:#827a83;"
                      >
                        {{ country.dial }}
                      </span>

                    </li>

                  </ul>

                </div>

              </div>


              <!-- =========================================
                   EMAIL ICON
              ========================================== -->
              <div
                *ngIf="!isPhoneInput()"
                class="absolute inset-y-0 left-0 flex items-center pl-4 pointer-events-none"
              >

                <svg
                  class="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  style="color:#827a83;"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.6"
                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                  />
                </svg>

              </div>

            </div>


            <!-- Helper -->
            <p
              *ngIf="isPhoneInput()"
              class="mt-2 text-xs"
              style="color:#827a83;"
            >
              Tap {{ selectedCountry.flag }} to change country code
            </p>


            <!-- Validation -->
            <p
              *ngIf="
                loginForm.get('phone')?.invalid &&
                loginForm.get('phone')?.touched
              "
              class="mt-2 text-xs"
              style="color:#d45d5d;"
            >
              Please enter a valid phone number or email address
            </p>

          </div>


          <!-- ===============================================
               SUBMIT
          ================================================ -->
          <button
            type="submit"
            [disabled]="loginForm.invalid || isLoading"
            class="w-full h-14 flex items-center justify-center gap-2.5 rounded-full text-base font-semibold transition-all duration-200"
            style="
              background:#8c52ff;
              color:#ffffff;
              letter-spacing:.01em;
              border:0;
              cursor:pointer;
            "
            [style.opacity]="
              loginForm.invalid || isLoading
                ? '0.55'
                : '1'
            "
          >

            <svg
              *ngIf="isLoading"
              class="animate-spin h-5 w-5"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                class="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                stroke-width="4"
              />

              <path
                class="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              />
            </svg>

            <span>
              {{ isLoading ? 'Logging in...' : 'Unlock Private Access' }}
            </span>

            <span
              *ngIf="!isLoading"
              aria-hidden="true"
              style="font-size:1.1rem;"
            >
              →
            </span>

          </button>


          <!-- ===============================================
               ERROR
          ================================================ -->
          <div
            *ngIf="errorMessage"
            class="flex items-start gap-3 rounded-2xl p-4"
            style="
              background:#fdf0f0;
              border:1px solid #f0c8c8;
            "
          >

            <svg
              class="w-5 h-5 shrink-0 mt-0.5"
              fill="currentColor"
              viewBox="0 0 20 20"
              style="color:#e87070;"
            >
              <path
                fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                clip-rule="evenodd"
              />
            </svg>

            <p
              class="text-sm leading-relaxed"
              style="color:#c05050;"
            >
              {{ errorMessage }}
            </p>

          </div>

        </form>


        <!-- =================================================
             CREATE ACCOUNT
        ================================================== -->
        <div class="mt-6 text-center">

          <p
            class="text-sm"
            style="color:#706971;"
          >
            New to CircledPlus?

            <a
              [routerLink]="['/signup']"
              [queryParamsHandling]="'preserve'"
              class="font-bold cursor-pointer hover:underline"
              style="color:#242126;"
            >
              Create a new account
            </a>
          </p>

        </div>


        <!-- =================================================
             TRUST / VALUE CARD
        ================================================== -->
        <div class="login-trust-section mt-7">

          <div
            class="rounded-2xl overflow-hidden"
            style="
              background:#ffffff;
              border:1px solid #e7e1dc;
              box-shadow:0 4px 18px rgba(0,0,0,0.035);
            "
          >

            <!-- Slider -->
            <div class="overflow-hidden">

              <div
                class="flex transition-transform duration-500 ease-out"
                [style.transform]="
                  'translateX(-' + (currentSlide * 100) + '%)'
                "
              >

                <!-- Slide 1 -->
                <div class="w-full min-w-full shrink-0 p-5">

                  <div class="flex items-center gap-4">

                    <div
                      class="w-12 h-12 shrink-0 rounded-full flex items-center justify-center"
                      style="background:#f0e8fc;"
                    >
                      <svg
                        width="21"
                        height="21"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M12 2L4 5.5v5c0 4.5 3.2 8.7 8 10 4.8-1.3 8-5.5 8-10v-5L12 2z"
                          stroke="#7641cf"
                          stroke-width="1.5"
                          stroke-linejoin="round"
                        />
                        <rect
                          x="9"
                          y="10.5"
                          width="6"
                          height="5"
                          rx="1"
                          stroke="#7641cf"
                          stroke-width="1.3"
                        />
                        <path
                          d="M10 10.5V9a2 2 0 014 0v1.5"
                          stroke="#7641cf"
                          stroke-width="1.3"
                          stroke-linecap="round"
                        />
                      </svg>
                    </div>

                    <div class="min-w-0">
                      <p
                        class="font-semibold text-sm"
                        style="color:#242126;"
                      >
                        No spam calls
                      </p>

                      <p
                        class="mt-1 text-xs leading-relaxed"
                        style="color:#706971;"
                      >
                        We only contact you if you request assistance.
                      </p>
                    </div>

                  </div>

                </div>


                <!-- Slide 2 -->
                <div class="w-full min-w-full shrink-0 p-5">

                  <div class="flex items-center gap-4">

                    <div
                      class="w-12 h-12 shrink-0 rounded-full flex items-center justify-center"
                      style="background:#f0e8fc;"
                    >
                      <svg
                        width="21"
                        height="21"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M12 2L4 5.5v5c0 4.5 3.2 8.7 8 10 4.8-1.3 8-5.5 8-10v-5L12 2z"
                          stroke="#7641cf"
                          stroke-width="1.5"
                          stroke-linejoin="round"
                        />
                        <rect
                          x="9"
                          y="10.5"
                          width="6"
                          height="5"
                          rx="1"
                          stroke="#7641cf"
                          stroke-width="1.3"
                        />
                        <path
                          d="M10 10.5V9a2 2 0 014 0v1.5"
                          stroke="#7641cf"
                          stroke-width="1.3"
                          stroke-linecap="round"
                        />
                      </svg>
                    </div>

                    <div class="min-w-0">
                      <p
                        class="font-semibold text-sm"
                        style="color:#242126;"
                      >
                        Your details stay private
                      </p>

                      <p
                        class="mt-1 text-xs leading-relaxed"
                        style="color:#706971;"
                      >
                        Your information is never shared publicly.
                      </p>
                    </div>

                  </div>

                </div>


                <!-- Slide 3 -->
                <div class="w-full min-w-full shrink-0 p-5">

                  <div class="flex items-center gap-4">

                    <div
                      class="w-12 h-12 shrink-0 rounded-full flex items-center justify-center"
                      style="background:#f0e8fc;"
                    >
                      <svg
                        width="21"
                        height="21"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M12 2L4 5.5v5c0 4.5 3.2 8.7 8 10 4.8-1.3 8-5.5 8-10v-5L12 2z"
                          stroke="#7641cf"
                          stroke-width="1.5"
                          stroke-linejoin="round"
                        />
                        <rect
                          x="9"
                          y="10.5"
                          width="6"
                          height="5"
                          rx="1"
                          stroke="#7641cf"
                          stroke-width="1.3"
                        />
                        <path
                          d="M10 10.5V9a2 2 0 014 0v1.5"
                          stroke="#7641cf"
                          stroke-width="1.3"
                          stroke-linecap="round"
                        />
                      </svg>
                    </div>

                    <div class="min-w-0">
                      <p
                        class="font-semibold text-sm"
                        style="color:#242126;"
                      >
                        Private access
                      </p>

                      <p
                        class="mt-1 text-xs leading-relaxed"
                        style="color:#706971;"
                      >
                        Explore curated homes not widely available on public portals.
                      </p>
                    </div>

                  </div>

                </div>


                <!-- Slide 4 -->
                <div class="w-full min-w-full shrink-0 p-5">

                  <div class="flex items-center gap-4">

                    <div
                      class="w-12 h-12 shrink-0 rounded-full flex items-center justify-center"
                      style="background:#f0e8fc;"
                    >
                      <svg
                        width="21"
                        height="21"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M12 2L4 5.5v5c0 4.5 3.2 8.7 8 10 4.8-1.3 8-5.5 8-10v-5L12 2z"
                          stroke="#7641cf"
                          stroke-width="1.5"
                          stroke-linejoin="round"
                        />
                        <rect
                          x="9"
                          y="10.5"
                          width="6"
                          height="5"
                          rx="1"
                          stroke="#7641cf"
                          stroke-width="1.3"
                        />
                        <path
                          d="M10 10.5V9a2 2 0 014 0v1.5"
                          stroke="#7641cf"
                          stroke-width="1.3"
                          stroke-linecap="round"
                        />
                      </svg>
                    </div>

                    <div class="min-w-0">
                      <p
                        class="font-semibold text-sm"
                        style="color:#242126;"
                      >
                        Member access protects seller privacy
                      </p>

                      <p
                        class="mt-1 text-xs leading-relaxed"
                        style="color:#706971;"
                      >
                        We identify members to maintain a curated and discreet marketplace.
                      </p>
                    </div>

                  </div>

                </div>

              </div>

            </div>


            <!-- Slider dots -->
            <div
              class="flex justify-center gap-2 pb-4"
            >

              <button
                *ngFor="let _ of slides; let i = index"
                type="button"
                (click)="goToSlide(i)"
                class="w-2 h-2 rounded-full transition-all duration-300"
                [style.background]="
                  i === currentSlide
                    ? '#8c52ff'
                    : '#ded1ef'
                "
                [style.transform]="
                  i === currentSlide
                    ? 'scale(1.25)'
                    : 'scale(1)'
                "
                [attr.aria-label]="'Slide ' + (i + 1)"
              ></button>

            </div>

          </div>

        </div>


        <!-- =================================================
             THREE TRUST POINTS
        ================================================== -->
        <div class="login-trust-section mt-7">

          <div class="grid grid-cols-3">

            <!-- Item 1 -->
            <div
              class="flex flex-col items-center text-center px-3"
            >

              <div
                class="w-10 h-10 rounded-full flex items-center justify-center"
                style="background:#f0e8fc;"
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M12 2l-7 4v6c0 5 3.5 9.7 7 11 3.5-1.3 7-6 7-11V6l-7-4z"
                    stroke="#8c52ff"
                    stroke-width="1.6"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>

              <span
                class="mt-2 text-[11px] leading-tight"
                style="color:#706971;"
              >
                Private and
                <br />
                secure access
              </span>

            </div>


            <!-- Divider -->
            <div class="flex items-stretch justify-center">
              <div
                class="w-px h-full"
                style="background:#e7e1dc;"
              ></div>
            </div>


            <!-- Item 2 -->
            <div
              class="flex flex-col items-center text-center px-3"
            >

              <div
                class="w-10 h-10 rounded-full flex items-center justify-center"
                style="background:#f0e8fc;"
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24"
                    stroke="#8c52ff"
                    stroke-width="1.6"
                    stroke-linecap="round"
                  />
                  <path
                    d="M1 1l22 22"
                    stroke="#8c52ff"
                    stroke-width="1.6"
                    stroke-linecap="round"
                  />
                </svg>
              </div>

              <span
                class="mt-2 text-[11px] leading-tight"
                style="color:#706971;"
              >
                Your details
                <br />
                stay confidential
              </span>

            </div>


            <!-- Divider -->
            <div class="flex items-stretch justify-center">
              <div
                class="w-px h-full"
                style="background:#e7e1dc;"
              ></div>
            </div>


            <!-- Item 3 -->
            <div
              class="flex flex-col items-center text-center px-3"
            >

              <div
                class="w-10 h-10 rounded-full flex items-center justify-center"
                style="background:#f0e8fc;"
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <circle
                    cx="9"
                    cy="7"
                    r="3"
                    stroke="#8c52ff"
                    stroke-width="1.6"
                  />

                  <path
                    d="M1 20c0-4 3.6-6 8-6s8 2 8 6"
                    stroke="#8c52ff"
                    stroke-width="1.6"
                    stroke-linecap="round"
                  />

                  <path
                    d="M19 8v6M16 11h6"
                    stroke="#8c52ff"
                    stroke-width="1.6"
                    stroke-linecap="round"
                  />
                </svg>
              </div>

              <span
                class="mt-2 text-[11px] leading-tight"
                style="color:#706971;"
              >
                Member access
                <br />
                protects seller privacy
              </span>

            </div>

          </div>

        </div>


        <!-- =================================================
             LEGAL
        ================================================== -->
        <div
          class="mt-6 pt-4"
          style="border-top:1px solid #e7e1dc;"
        >

          <p
            class="text-center text-[11px] leading-relaxed"
            style="color:#706971;"
          >
            By signing in, you agree to our

            <a
              [routerLink]="['/termsandcondition']"
              class="font-bold hover:underline"
              style="color:#242126;"
            >
              Terms &amp; Conditions
            </a>

            and

            <a
              [routerLink]="['/privacypolicy']"
              class="font-bold hover:underline"
              style="color:#242126;"
            >
              Privacy Policy
            </a>
          </p>

        </div>


      </div>
    </div>

  </main>

</div>